/* JHERR · Tarjeta nueva en todo el sitio (complemento de jherr-card-plus.js).
   - Botón "Agregar al carrito" de la tarjeta en páginas donde el tema no trae su script.
   - "Vistos recientemente": cambia las tarjetas antiguas por la tarjeta nueva. */
(function () {
  'use strict';
  if (window.__jhCardSite) return;
  window.__jhCardSite = true;

  /* ---------- Agregar al carrito desde la tarjeta (respaldo si la página no trae el script del tema) ---------- */
  if (typeof window.handleQuickAdd !== 'function') {
    window.handleQuickAdd = function (event, form) {
      event.preventDefault();
      var button = form.querySelector('.add-to-cart-button');
      var text = form.querySelector('.add-to-cart-text');
      var id = form.querySelector('input[name="id"]');
      if (!id || (button && button.disabled)) return false;
      var original = text ? text.textContent : '';
      if (button) button.disabled = true;
      if (text) text.textContent = 'Agregando...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id.value, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar'); return j; }); })
        .then(function (item) {
          if (text) text.textContent = '✓ Agregado';
          setTimeout(function () { if (button) button.disabled = false; if (text) text.textContent = original; }, 1800);
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('.cart-count, .site-header__cart-count, [data-cart-count], .cart__count, .header-cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
                if (cart.item_count > 0) el.classList.remove('hide');
              });
            })
            .catch(function () {});
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: item } }));
        })
        .catch(function (err) {
          if (button) button.disabled = false;
          if (text) text.textContent = original;
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', { bubbles: true, detail: { errorMessage: err.message } }));
        });
      return false;
    };
  }

  /* ---------- "Vistos recientemente": misma tarjeta que la colección ----------
     El tema arma esas tarjetas con su diseño antiguo; aquí se cambian por la tarjeta nueva
     (sections/jherr-product-card.liquid), con un fundido, sin saltos. */
  function cardFor(handle) {
    var t = window.Shopify && Shopify.theme;
    var preview = t && t.role && t.role !== 'main' && t.id ? '&preview_theme_id=' + t.id : '';
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=jherr-product-card' + preview, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var box = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-jh-product-card]');
        return box && box.querySelector('.jh-card');
      })
      .catch(function () { return null; });
  }
  function upgradeRecent(out, widthClasses) {
    if (!out || out.__jhUpgrading) return;
    var handles = [];
    Array.prototype.forEach.call(out.querySelectorAll('a[href*="/products/"]'), function (a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m && handles.indexOf(m[1]) === -1) handles.push(m[1]);
    });
    if (!handles.length || out.querySelector('.jh-card')) return;
    out.__jhUpgrading = true;
    out.style.transition = 'opacity .3s ease';
    out.style.opacity = '0';
    Promise.all(handles.map(cardFor)).then(function (cards) {
      var frag = document.createDocumentFragment();
      cards.forEach(function (c) {
        if (!c) return;
        var el = document.importNode(c, true);
        if (widthClasses) {
          el.className = el.className.split(/\s+/).filter(function (k) { return !/^(small|medium|medium-up|large-up|widescreen)--/.test(k); }).join(' ') + ' ' + widthClasses;
        }
        frag.appendChild(el);
      });
      if (frag.childNodes.length) {
        out.innerHTML = '';
        out.appendChild(frag);
        document.dispatchEvent(new CustomEvent('jherr:collection-products-loaded', { detail: { container: out } }));
      }
      out.style.opacity = '';
      out.__jhUpgrading = false;
    });
  }
  function watchRecent() {
    document.querySelectorAll('[data-section-type="recently-viewed"]').forEach(function (sec) {
      var out = sec.querySelector('[id^="RecentlyViewed-"]');
      if (!out || out.__jhWatch) return;
      out.__jhWatch = true;
      var widths = sec.getAttribute('data-grid-item-class') || '';
      new MutationObserver(function () { upgradeRecent(out, widths); }).observe(out, { childList: true });
      upgradeRecent(out, widths);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchRecent); else watchRecent();
  document.addEventListener('shopify:section:load', watchRecent);
})();